import { Link } from '@tanstack/react-router'

import { WhatsAppSendingSwitch } from '@/components/WhatsAppSendingSwitch'
import { ReminderSettingsPanel } from '@/screens/ReminderSettingsPanel'
import { WhatsAppTemplateConfigSection } from '@/screens/WhatsAppTemplateConfigSection'

/**
 * Reminders > Configure tab — the master sending switch, the reminder schedule
 * and the message templates (one per reminder purpose, with an example of
 * each). The switch also appears on the admin Settings page, which keeps the
 * Twilio connection and the send delay.
 */
export function WhatsAppSettingsTab() {
  return (
    <div className="space-y-6">
      <WhatsAppSendingSwitch />
      <ReminderSettingsPanel />
      <WhatsAppTemplateConfigSection />
      <p className="text-[13px] text-slate-500">
        The Twilio connection and the send delay are managed by admins on the{' '}
        <Link to="/settings" className="font-medium text-blue-700 hover:underline">
          Settings
        </Link>{' '}
        page.
      </p>
    </div>
  )
}
